import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StatusOverviewComponent } from './pages/overview/status-overview.component';

const routes: Routes = [
  {
    path: '',
    component: StatusOverviewComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class StatusRoutingModule {}
